// Environment handling. Values come from Vite (import.meta.env, VITE_* only).
// Access is lazy so a missing value fails at first use with a clear message rather
// than crashing module load or the production build.
export interface AppEnv {
  readonly supabaseUrl: string;
  readonly supabaseAnonKey: string;
}

function require(name: keyof ImportMetaEnv): string {
  const value: unknown = import.meta.env[name];
  if (typeof value !== 'string' || value.length === 0) {
    throw new Error(`Missing environment variable: ${name}`);
  }
  return value;
}

let cached: AppEnv | null = null;

export function getEnv(): AppEnv {
  if (cached === null) {
    cached = {
      supabaseUrl: require('VITE_SUPABASE_URL'),
      supabaseAnonKey: require('VITE_SUPABASE_ANON_KEY'),
    };
  }
  return cached;
}
